<template>

	  <!--bottom-->
	  <div class="bg4">
	    <div class="bottom">
	      <div class="bottom1">
	        <div class="bottom1_1">
	          <div class="bottom_t">关于我们</div>
	          <ul class="link_list">
	            <li><a href="javascript:void(0)" @click="go('/about?id=1665618104755376128')">· 公司介绍</a></li>
	            <li><a href="javascript:void(0)" @click="go('/about?id=1665618176524111872')">· 企业文化</a></li>
	            <li><a href="javascript:void(0)" @click="go('/about?id=1665618228105662464')">· 企业荣誉</a></li>
	          </ul>
	        </div>
	        <div class="bottom1_1">
	          <div class="bottom_t">新闻资讯</div>
	          <ul class="link_list">
	            <li><a href="javascript:void(0)" @click="go('/newList?type=1002')">· 行业新闻</a></li>
	            <li><a href="javascript:void(0)" @click="go('/newList?type=1001')">· 公司新闻</a></li>
	          </ul>
	        </div>
	        <div class="bottom1_2">
	          <div class="bottom_t">青岛流亭机场酒厂</div>
	          <p>地址：山东省青岛市城阳区鑫山路5号</p>
	          <p>电话：(0532)84711938 </p>
	        </div>
	        <div class="bottomPart2">
	          <div class="codeCon">
	            <li class="item">
	              <div class="Img c01"> <img src="@/assets/images/wx.svg"></div>
	              <span>微信</span>
	              <div class="clearfix"></div>
	              <div class="tooltip">
	                <div class="ImgCode"> <img src="@/assets/images/wxcode.png">
	                  <p>微信</p>
	                </div>
	                <div class="arrow"></div>
	              </div>
	            </li>
	            <li class="item">
	              <div class="Img c02"> <img src="@/assets/images/sina.svg"></div>
	              <span>微博</span>
	              <div class="clearfix"></div>
	              <div class="tooltip">
	                <div class="ImgCode"> <img src="@/assets/images/wobo.png">
	                  <p>微博</p>
	                  <div class="arrow"></div>
	                </div>
	              </div>
	            </li>
	          </div>
	        </div>
	      </div>
	      <div class="bottom2">Copyright © 2022 青岛流亭机场酒厂  <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备10027067号-1</a> </div>
	      <!--shouji bottom-->
	      
		  
	     <div class="bottom3">
	        <p>公司地址：山东省青岛市城阳区鑫山路5号</p>
	        <p>电话：0532-84711938   技术支持：<a href="http://www.qdbc.com.cn/" target="_blank">北辰科技</a></p>
	        <p>联系邮箱：qdltjc@qdltjc.com</p>
	        <p>Copyright © 2022 青岛流亭机场酒厂 鲁ICP备10027067号-1 </p>
	      </div>
	    </div>
	  </div>
	  <!--bottom--> 

</template>
<script>
export default {
  data(){
    return{
      env: {
        bimp: process.env.HZY_BIMP_URL,
        tcp: process.env.HZY_URL,
        ecp: process.env.HZY_SHOP_URL
      }
    }
  },
  methods:{
	  go(url){
	  	if(this.$route.fullPath!=url){
	  		this.$router.push(url)
	  		this.$router.go(0)
	  	}
	  }
  }

}
</script>
<style scoped>


</style>
